import { isArray, isEmpty, isObject, mapValues, omitBy } from "lodash-es";

/**小数格式化
 * @params number 需要格式化的数字
 * @params maxDecimalPlaces 最大保留小数
 */
export const decimalFormatter = (number: number, maxDecimalPlaces: number) => {
    // 将数字转换为字符串
    const numberString = number.toString();

    // 查找小数点的位置
    const decimalIndex = numberString.indexOf(".");

    // 如果找到小数点
    if (decimalIndex !== -1) {
        // 获取小数部分
        const decimalPart = numberString.substring(decimalIndex + 1);

        // 截取小数部分，确保不超过最大位数
        const truncatedDecimalPart = decimalPart.substring(0, maxDecimalPlaces);

        // 拼接整数部分和截取后的小数部分
        return Number.parseFloat(numberString.substring(0, decimalIndex + 1) + truncatedDecimalPart);
    }

    // 如果没有小数点，直接返回原数字
    return Number.parseFloat(numberString);
};

/**时间戳转天数 */
export function formatTimeFromTimestamp(timestamp: number): string {
    const totalSeconds = Math.floor(timestamp / 1000);
    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    // const seconds = totalSeconds % 60;

    let formattedTime = "";
    if (days > 0) {
        formattedTime += days + "天";
    }
    if (hours > 0) {
        formattedTime += hours + "小时";
    }
    if (minutes > 0) {
        formattedTime += minutes + "分钟";
    }
    // if (seconds > 0 || formattedTime === "") {
    //     formattedTime += seconds + "秒";
    // }

    return formattedTime.trim();
}

// 格式化年月日日期
export const formatChineseDate = (dateStr: string) => {
    // 匹配中文日期格式
    const regex = /(\d{4})年(\d{1,2})月(\d{1,2})日/;
    const match = dateStr.match(regex);

    if (!match) {
        console.error("日期格式不符合要求：YYYY年MM月DD日");
        // 无法解析时保留原始值，避免无效身份证日期导致页面直接抛出异常。
        return dateStr;
    }

    const year = match[1];
    const month = String(match[2]).padStart(2, "0"); // 补零操作
    const day = String(match[3]).padStart(2, "0"); // 补零操作

    return `${year}-${month}-${day}`;
};

/**
 * 将时间秒数格式化为英文时间字符串
 * @param time - 时间秒数
 * @returns 格式化后的时间字符串，格式为"XminYs"或"-"
 */
export function formatTimeEn(time: number): string {
    if (!time) return "--";

    let timeString = "";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);

    if (minutes > 0) {
        timeString += minutes + "min";
    }

    if (seconds > 0) {
        timeString += seconds + "s";
    }

    if(!minutes && seconds < 1){
        timeString = "<1s";
    }

    return timeString;
}

const isEmptyValue = (value: any) => value === "" || value === null || value === undefined;
/**
 * 递归清理对象或数组中的空值
 * @param data - 要清理的数据
 * @returns 清理后的结果
 */
export const deepClean = (data: any): any => {
    if (isArray(data)) {
        return data.map(deepClean).filter(item => !isEmpty(item));
    }

    if (isObject(data)) {
        return omitBy(mapValues(data, deepClean), isEmptyValue);
    }

    return data;
};
